<template>
	<b-container class="show-document">
		<div class="doc-body" style="text-align: center; align-items: center">
			<div class="actions mb-2 mt-2 hidden-print">
				<div class="pull-left">
					<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
				</div>
				<div class="pull-right">
					<b-button variant="outline-dark" class="mr-2" @click="print">
						<i class="fa fa-print"></i> Печать {{ $t('incomes.create.prices') }}
					</b-button>
					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>
			</div>
			<div>
				<div class="printElement" v-for="(item, index) in items" :key="`transfer-prices-generate-${index}`">
					<p class="text-center specialBarcode" style="padding-top: 20px"><b>{{item.barcode}}</b></p>
					<p class="text-center info">{{ item.itemName }}</p>
					<p><b class="price">€ {{ item.price * (item.multiBarcode[0].ratio ? item.multiBarcode[0].ratio : 1) }}</b></p>
					<barcode :value="item.multiBarcode[0]" :options="{height: '25px', displayValue: false}" tag="svg"></barcode>
					<p class="barcode"><b>{{ item.multiBarcode[0] }}</b></p>
				</div>
			</div>
			<div v-if="loading" class="text-center">
				<b-spinner small class="mr-2"/><strong>Loading...</strong>
			</div>
		</div>
	</b-container>
</template>

<script>
import ReportService from "./report.service";
import {mapState} from "vuex";

export default {
	name: "warehousePrices",
	data() {
		return {
			loading: false
		}
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		async print() {
			window.print();
		}
	},
	computed: {
		...mapState("warehouse", {'items': "pricingItems"}),
	},
	created() {
		if (this.items.length > 0) {
		} else {
			this.goBackToFrom();
		}
	}
}
</script>

<style scoped>
body {
	background-color: white !important;
}

.printElement {
	padding-left: 10px !important;
	text-align: center;
	page-break-before: always;
	page-break-after: always;
	page-break-inside: avoid;
	word-break: break-all;
	color: #000;
	width: 100mm !important;
	height: 50mm !important;
	border: 1px dashed #868686;
	background-color: white;
}
.printElement svg {
	width: 100% !important;
	margin-top: -3px;
}

.printElement p {
	font-family: "Arial Black", Gadget, sans-serif;
	text-align: center;
	color: #000000 !important;
	font-weight: bold;
	font-size: 15px !important;
	margin: 0;
	line-height: 1;
}

.specialBarcode {
	font-size: 17px;
	padding-left: 40%;
}

.printElement .price {
	margin-top: -5px !important;
	font-size: 55px !important;
}
.printElement p.barcode {
	font-size: 10px;
}

@media print {
	html, body {
		margin: 0 !important;
		text-align: center;
		padding: 0 !important;
	}
	* {
		box-sizing: border-box;
		padding: 0;
		margin: 0;
	}
	@page { size: landscape; }
	.hidden-print {
		display: none;
	}
	.printElement {
		border: none;
	}

}
</style>
